import { useState } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/data";

export default function HeroSection() {
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20golden%20geometric%20pattern%20with%20soft%20gradient%20lighting%2C%20minimalist%20luxury%20background%20with%20subtle%20texture%2C%20elegant%20atmospheric%20ambiance%2C%20dark%20overlay%20ready%20composition%2C%20professional%20and%20trustworthy%20vibe%2C%20no%20text%2C%20clean%20aesthetic%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20soft%20bokeh%20effect%20in%20corners%2C%20high%20contrast%20between%20light%20and%20shadow%20areas%2C%20modern%20corporate%20style%20with%20artistic%20flair&width=1600&height=900&seq=hero-kaiyun-2026&orientation=landscape"
          alt="kaiyun.con 官方导航入口"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-6 text-center py-12">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
          <div className="w-2 h-2 rounded-full bg-accent-400"></div>
          <span className="text-xs text-background-50/90 font-medium">2026 最新导航入口</span>
        </div>

        <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 mb-4 leading-tight">
          kaiyun.con 官方入口 · 快速直达
        </h1>

        <p className="text-sm md:text-base text-background-50/80 max-w-[680px] mx-auto mb-8 leading-relaxed">
          开云平台重要参考导航，汇聚注册登录指引、使用指南及常见问题解答，帮助您快速定位、安全访问，节省查找时间，立即了解 kaiyun.con 全部功能与服务详情。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
          <Link
            to="/category/pingtai-daohang"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-compass-3-line text-base w-5 h-5 flex items-center justify-center"></i>
            查看导航指引
          </Link>
          <Link
            to="/category/shiyong-zhinan"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 text-background-50 border border-background-50/30 font-medium rounded-md hover:bg-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-book-open-line text-base w-5 h-5 flex items-center justify-center"></i>
            了解更多
          </Link>
        </div>

        <div className="max-w-[480px] mx-auto">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3.5 pointer-events-none">
              <i className="ri-search-line text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
            </div>
            <input
              type="text"
              placeholder="搜索文章、指南、常见问题..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-10 pr-4 py-2.5 bg-background-50/90 backdrop-blur-sm text-foreground-900 text-sm rounded-md border border-background-200/50 focus:outline-none focus:ring-2 focus:ring-primary-400/40 transition-all duration-200 placeholder:text-foreground-400"
            />
          </div>
          {searchQuery && (
            <div className="mt-2 bg-background-50 rounded-md border border-background-200/70 p-3 text-left">
              <p className="text-xs text-foreground-500 mb-2">搜索 "{searchQuery}" 的结果：</p>
              {categories
                .filter((c) =>
                  c.name.includes(searchQuery) ||
                  c.description.includes(searchQuery)
                )
                .slice(0, 3)
                .map((c) => (
                  <Link
                    key={c.id}
                    to={`/category/${c.slug}`}
                    className="block px-2 py-1.5 rounded text-sm text-foreground-700 hover:bg-background-100 transition-colors duration-150 whitespace-nowrap"
                  >
                    {c.name} - {c.description.slice(0, 30)}...
                  </Link>
                ))}
              {categories.filter((c) =>
                c.name.includes(searchQuery) ||
                c.description.includes(searchQuery)
              ).length === 0 && (
                <p className="text-xs text-foreground-400 px-2">未找到相关内容</p>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}